export const GET_PAYMENTS_LIST = "GET_PAYMENTS_LIST";
export const GET_PAYMENTS_LIST_ERROR = "GET_PAYMENTS_LIST_ERROR";
export const GET_PAYMENTS_LIST_SUCCESS = "GET_PAYMENTS_LIST_SUCCESS";

export const GET_PAYMENT = "GET_PAYMENT";
export const GET_PAYMENT_SUCCESS = "GET_PAYMENT_SUCCESS";
export const GET_PAYMENT_ERROR = "GET_PAYMENT_ERROR";
export const GET_PAYMENT_CLEAR = "GET_PAYMENT_CLEAR";
